export function guid() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    const b = crypto.getRandomValues(new Uint8Array(16));
    b[6] = (b[6] & 0x0f) | 0x40;
    b[8] = (b[8] & 0x3f) | 0x80;
    return Array.from(b, x => x.toString(16).padStart(2, '0')).join('').replace(/(.{8})(.{4})(.{4})(.{4})/, '$1-$2-$3-$4-');
  }
  if (!guid._fp) guid._fp = Array.from({ length: 32 }, () => Math.floor(Math.random() * 16).toString(16)).join('');
  const t = Math.floor(((typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now()) * 1000).toString(16);
  const c = (guid._c = (guid._c || 0) + 1).toString(16);
  const r = Array.from({ length: 12 }, () => Math.floor(Math.random() * 16).toString(16)).join('');
  return [(t + guid._fp).slice(0, 8), (c + guid._fp).slice(0, 4), (guid._fp.slice(4) + t).slice(0, 4), (t.slice(8) + guid._fp.slice(8)).slice(0, 4), (guid._fp.slice(12) + r + c).slice(0, 12)].join('-');
}